var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "url(#pattern0_7952_874)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_7952_874",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7952_874",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7952_874",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADwUlEQVR4nO3cv2sUQRQH8LkYtbOIksu8i2Bhpaig2FpYWNhqbBUUwSKFeu9dBOUC/gtqYbC10EYEbURjKwSEmGQm8QfaGQW74I/8GNkLSmLuNneS7LyZeV945Q1v95OZud3snlISiUQikUgkEolEIpFIJJuaStUe1GTvAdpPmuwvIOs2tsysRjuu0T6Eqjmnr9hdQto0rgRk64BmceMRcgrtPJAZ2Y0GmveVZFxJo7lTKMRamDmo2Uu+zwSDOP8YKyrrRdVHu1XCGLd8I6xBIXNbpRfHamasqbSWL1csBtp5jeYVoHkEZF9qtN/a+MxcIhu9Kw4j26jJ3ui/PNGzqoX6aHdf1ZzSZGfyP2/uqrjjCsQwXzROHc7rpmdwZocm8yxvZsHQ1E4VZ1yRGIt9telj7XTVQEH7tvV4U2dVfHFFb+D3O+muQuZ0q7GyK3oVV1zhX211depEJx0euTi2tdVGr8m8VvHE+bnO+I91P/v21Xw8M6viiPN2nbF3cGZ7p91qtI9bgCyp8OO8XvSVa2ZPpx0D2rFW46mw47xfgWuy5zvpOLsFD2QWIgRxLO5NZf/vUANuS7tda7I388ZTYcZ5nxmrUcxwO133DdmjGs33yEB4YSyXWWqg5MyUSs0eBzJf1xtLhRWOGHZlvdFoL2Qb/b76xLbea+PlCk6f1GQfZGjtjKHCCY89Aza5VBhJAwPCAEkHA/iDpIUBvEHSwwC+IGliAE+QdDGAH0jaGMALRDCAD4hgAJ8ZIhjAZ8kSDOCzhwgG8NnU2d+1dT5Ko/0pGMSpzAeZGcQKZKToZSrpiz7IKzSLldr0IcEgNiDXi8SQDZzWebVNuVJRGLJMUe7MuKvqrkswKD0MWaaIxTKVPUxshr3/9RHjKm5mKNVfMwcK/4UECqiKxMjS+O0Q3wdNPKvQZepPgOxH3wcODMsLRhZN5ofvgwdm5Q0jSzsPFKdU2idGAwTNU98nAVLdwJuCkD3j/USQ//I+M/6m7ro02Re+TwgIxpr36CZ9nxhIemb8k/LVd73ZCyy+TxCktmfkJSkUZI6RFAoGgpEECgaGETUKBooRJQoGjhEVCkaCEQUKRoYRNApGihEkCkaOERQKJoIRBAomhsEaBRPFYImCiWOwQkHB4IOCgsFnpqBg8Fm+UDD47CkoGHxQUDD4oKBg8EFBweCDgoLBBwUFgw8KCgYfFBSMwh5b1Wiet8YwC8sv5TN8vDPeuFIF7YAm8wTQfm68NITmfTYryjS533d3EolEIpFIJBKJRCKRSFTk+Q05ltZrxX+1JAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTag);
export default __webpack_public_path__ + "static/media/Price Tag.8fea36373a2b361fc97549a862f380a8.svg";
export { ForwardRef as ReactComponent };